import { notifications } from '@mantine/notifications';
import { Logger } from 'src/utils/Logger';
import { ApiError, ApiErrorCode } from 'src/error/ApiError';

export const notifyAndLogError = (
  title: string,
  message: string,
  error: unknown,
  additionalInfo: Record<string, unknown> = {},
) => {
  const isIntegrityError =
    error instanceof ApiError && error.code === ApiErrorCode.ENTITY_HAS_DEPENDENCIES;

  // The backend's message already says what to do, so it replaces the caller's generic one. The
  // refusal is expected, so it is only left as a breadcrumb rather than reported as an error.
  if (ApiError.isApiError(ApiErrorCode.CONNECTED_ASSET_IDENTIFIER_CHANGE, error)) {
    notifications.show({ title, message: error.message, color: 'red' });
    Logger.info(`${title}: ${error.message}`, additionalInfo);
    return;
  }

  if (!isIntegrityError) {
    notifications.show({ title, message, color: 'red' });
    Logger.error(`${title}: ${message}`, error, additionalInfo);
    return;
  }

  Logger.warn(`${title}: ${message}`, additionalInfo);
};

export const notifyAndWarn = (
  title: string,
  message: string,
  additionalInfo: Record<string, unknown> = {},
) => {
  notifications.show({ title, message, color: 'amber' });
  Logger.warn(`${title}: ${message}`, additionalInfo);
};
